import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'PIs',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'pis',
                },
              },
              subqueries: {
                pis: {
                  filter: {
                    and: [
                      {
                        not: {
                          '=': [
                            {
                              '@': 'projectOrgs',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdc',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdc',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdcDensity',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdcDensity',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcDensityMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'asf',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'asf',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'asfMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'effectiveRecovery',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'effectiveRecovery',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'effectiveRecoveryMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          tdc: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'glExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'tdcAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          code: {
                            '{}': {
                              value: {
                                '@.': '!code',
                              },
                            },
                          },
                          mtdc: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'glExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdcAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          name: {
                            '{}': {
                              value: {
                                '@.': '!name',
                              },
                            },
                          },
                          projects: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'projectOrgs',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  subqueries: {
                    glExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectOrgs',
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          idcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'IDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          tdcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'TDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          mtdcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!code',
                          },
                        },
                      },
                    },
                    projectOrgs: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!id',
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    not: {
                      '=': [
                        {
                          '@': 'projectOrgs',
                        },
                        null,
                      ],
                    },
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdc',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'mtdc',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'mtdcMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'mtdcDensity',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'mtdcDensityMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'asf',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'asf',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'asfMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'effectiveRecovery',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'effectiveRecoveryMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              period: {
                '``': {
                  '@$': 'focusedRange',
                },
              },
              target: 'ent:!personnel:!employee',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      tdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'projectOrgs',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                glExpenses: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  using: 'projectOrgs',
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '{}': {
                      idcAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'IDC',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      tdcAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'TDC',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                      mtdcAmount: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '@': 'costType',
                                },
                                'MTDC',
                              ],
                            },
                            {
                              '@.': '!amount',
                            },
                          ],
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    costType: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!code',
                      },
                    },
                  },
                },
                projectOrgs: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!proj',
                  },
                  using: 'projectPiAssignments',
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '@.': '!id',
                  },
                },
                projectPiAssignments: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!pi',
                  },
                  target: 'ent:!proj_pis:!entry',
                },
              },
            },
          },
          columns: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!personnel#!employee:!code',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!personnel#!employee:!name',
                        },
                      },
                    },
                  },
                ],
              },
              {
                '[]': [
                  {
                    '{}': {
                      id: 'tdc',
                      direct: {
                        '{}': {
                          name: 'TDC Expense',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'mtdc',
                      direct: {
                        '{}': {
                          name: 'MTDC Expense',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'projects',
                      direct: {
                        '{}': {
                          name: 'Projects',
                          type: 'INT',
                        },
                      },
                    },
                  },
                ],
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      tdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'projectOrgs',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        not: {
                          '=': [
                            {
                              '@': 'projectOrgs',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdc',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdc',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdcDensity',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdcDensity',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcDensityMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'asf',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'asf',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'asfMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'effectiveRecovery',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'effectiveRecovery',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'effectiveRecoveryMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '{}': {
                      tdc: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'glExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      mtdc: {
                        '??': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'glExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          0,
                        ],
                      },
                      projects: {
                        '??': [
                          {
                            '#': {
                              '@': 'projectOrgs',
                            },
                          },
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    glExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectOrgs',
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          idcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'IDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          tdcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'TDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          mtdcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!code',
                          },
                        },
                      },
                    },
                    projectOrgs: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '@.': '!id',
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
  },
}
